import React from 'react';
import img from '../images/about.png';
import { Link } from 'react-router-dom';
import'./Navbar/style.css'

const Intro = () => {
    return (
        <>
                <div className="m-auto max-w-6xl p-2 md:p-12 h-5/6" style={{background:'#C9D2DD'}} id='about' >
                    <h1 style={{justifyContent:'center', textAlign:'center', fontSize:'70px'}}>About us</h1>
                    <div className="flex flex-col-reverse lg:flex-row py-8 justify-between lg:text-left" data-aos="fade-up">

                        <div className="flex-col my-4 text-center lg:text-left lg:my-0 lg:justify-end w-full lg:w-1/2 px-8" data-aos="zoom-in" data-aos-delay="500">

                            <h3 className="text-3xl   font-bold" style={{color:'#2095A1'}}>Since 2019,</h3>
                            <div>
                                <p className='my-3 text-s  font-regular'>we are bound to provide complete, hassle free, sustainable power solution for entire spectrum of electricity consumers by Providing uninterrupted, Innovative cutting-edge technology with spirit of pioneering and making earth greener and a better place to live.</p>
                            </div>

                            <div>
                                <p className='my-3 text-s  font-regular'>Visibility improves our ability to work in odd conditions, also enhancing the looks, adding safety and increases productivity. Thus making our lives comfortable, secured and hasselfree.</p>
                            </div>
                            <Link to="/contact" className="text-white bg-orange-500 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-2 my-4 text-lg shadow-xl rounded-2xl sm:w-auto sm:mb-0 group">
                                Contact us
                                <svg className="w-4 h-4 ml-1 group-hover: translate-x-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                            </Link>
                        </div>
                        <div className="lg:w-1/2 flex flex-col lg:mx-4 justify-center">
                            <img alt="card img" className="rounded-t float-right" src={img} />
                        </div>
                    </div>
                </div>
        </>
    )
}

export default Intro;